export default "__VITE_ASSET__lSXZymcA__"